import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  ORDER_HISTORY_SOURCE_PAGE,
  ORDER_DETAILS_SOURCE_PAGE,
  ORDER_CONFIRMATION_SOURCE_PAGE,
} from '../../constants/orderdetailsui';

export const SourcePageContext = createContext({
  sourcePage: '',
  isConfirmationPage: false,
});

export const SourcePageProvider = props => {
  const { children, override, isConfirmation } = props;

  const orderDetailsSourcePageContextValues = useMemo(
    () => ({
      sourcePage: isConfirmation
        ? ORDER_CONFIRMATION_SOURCE_PAGE
        : ORDER_DETAILS_SOURCE_PAGE,
      isConfirmationPage: isConfirmation,
    }),
    [isConfirmation]
  );

  const orderHistorySourcePageContextValues = useMemo(
    () => ({
      sourcePage: ORDER_HISTORY_SOURCE_PAGE,
      isConfirmationPage: false,
    }),
    []
  );

  // if override is provided, we are in the order details / confirmation flow,
  // wait for the url to be parsed to know if we are on the confirmation page
  if (override) {
    if (isConfirmation !== null) {
      return (
        <SourcePageContext.Provider value={orderDetailsSourcePageContextValues}>
          {children}
        </SourcePageContext.Provider>
      );
    }
  }

  return (
    <SourcePageContext.Provider value={orderHistorySourcePageContextValues}>
      {children}
    </SourcePageContext.Provider>
  );
};

SourcePageProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  override: PropTypes.bool,
  isConfirmation: PropTypes.bool,
};

SourcePageProvider.defaultProps = {
  override: false,
  isConfirmation: null,
};
